/**
 * Created by fan on 3/1/18.
 */

require('./images/favicon-32x32.png');
require('./404.html');

require('./vendors.js');
require('./smartorg-global.js');
import './lib/smartorg-api/smartorg';
require('./app.js');
require('./version.js');


// WEBPACK FOOTER //
// ./app/index.js